import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum BannerMessageType {
	error,
	success,
}

export interface BannerMessage {
	type: BannerMessageType;
	message: string;
	automationId?: string;
}

@Injectable({
	providedIn: 'root',
})
export class BannerMessageService {
	private readonly bannerMessageSubject: Subject<BannerMessage> =
		new Subject<BannerMessage>();

	constructor() {}

	public bannerMessages(): Observable<BannerMessage> {
		return this.bannerMessageSubject.asObservable();
	}

	public sendMessage(
		message: string,
		type: BannerMessageType = BannerMessageType.success,
		automationId?: string
	): void {
		const bannerMessage: BannerMessage = { message, type, automationId };
		this.bannerMessageSubject.next(bannerMessage);
	}
}
